import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_FULL } from "@/lib/api";
import JobDetail from "@/pages/JobDetail";
import { ArrowLeft, LogOut } from "lucide-react";

export default function ContractorJob() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-100">
      <header className="bg-navy px-5 py-4 flex items-center justify-between">
        <img src={LOGO_FULL} alt="True Seal Caulking" className="h-12 object-contain" />
        <div className="flex items-center gap-3 text-white">
          <span className="text-sm hidden sm:block text-slate-300">{user?.name}</span>
          <button data-testid="contractor-logout" onClick={logout} className="flex items-center gap-1.5 text-sm bg-white/10 hover:bg-white/20 rounded-lg px-3 py-2"><LogOut className="w-4 h-4" />Sign out</button>
        </div>
      </header>
      <div className="max-w-4xl mx-auto p-4 sm:p-6 pb-20">
        <button data-testid="job-back-button" onClick={() => navigate("/onboarding")} className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-navy mb-4"><ArrowLeft className="w-4 h-4" />Back to dashboard</button>
        <JobDetail />
      </div>
    </div>
  );
}
